/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AppPropsResponse,
    AppPropsResponseFromJSON,
    AppPropsResponseToJSON,
    BadRequestErrorResponse,
    BadRequestErrorResponseFromJSON,
    BadRequestErrorResponseToJSON,
    ConflictErrorResponse,
    ConflictErrorResponseFromJSON,
    ConflictErrorResponseToJSON,
    GlobalSettingsRequest,
    GlobalSettingsRequestFromJSON,
    GlobalSettingsRequestToJSON,
    GlobalSettingsResponse,
    GlobalSettingsResponseFromJSON,
    GlobalSettingsResponseToJSON,
} from '../models';

export interface UpdateGlobalSettingsRequest {
    globalSettingsRequest: GlobalSettingsRequest;
}

/**
 * 
 */
export class GlobalSettingsApi extends runtime.BaseAPI {

    /**
     * Read app properties.
     */
    async readAppPropsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<AppPropsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/globalSettings/appProps`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppPropsResponseFromJSON(jsonValue));
    }

    /**
     * Read app properties.
     */
    async readAppProps(initOverrides?: RequestInit): Promise<AppPropsResponse> {
        const response = await this.readAppPropsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Read global settings.
     */
    async readGlobalSettingsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<GlobalSettingsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/globalSettings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GlobalSettingsResponseFromJSON(jsonValue));
    }

    /**
     * Read global settings.
     */
    async readGlobalSettings(initOverrides?: RequestInit): Promise<GlobalSettingsResponse> {
        const response = await this.readGlobalSettingsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Update global settings.
     */
    async updateGlobalSettingsRaw(requestParameters: UpdateGlobalSettingsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.globalSettingsRequest === null || requestParameters.globalSettingsRequest === undefined) {
            throw new runtime.RequiredError('globalSettingsRequest','Required parameter requestParameters.globalSettingsRequest was null or undefined when calling updateGlobalSettings.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/globalSettings`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: GlobalSettingsRequestToJSON(requestParameters.globalSettingsRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update global settings.
     */
    async updateGlobalSettings(requestParameters: UpdateGlobalSettingsRequest, initOverrides?: RequestInit): Promise<void> {
        await this.updateGlobalSettingsRaw(requestParameters, initOverrides);
    }

}
